import cx from 'classnames';

import {Button} from '#component/base/Button';
import {Text} from '#component/base/Text';
import {InnerAccordion} from '#component/util';
import {InnerAccordionProps} from '#component/util/InnerAccordion';

import * as css from './Accordion.css';

/**
 * The Base Accordion component is a pre-styled version of the Accordion
 * component that exists in '#component/util'.
 *
 * It accepts an identical prop interface and features the same behaviours as
 * the "util" version of the Accordion. For more information, refer to the
 * documentation for that component.
 */
export const Accordion = ({
  trigger,
  triggerClassName,
  buttonClassName,
  ...otherProps
}: InnerAccordionProps) => (
  <InnerAccordion
    triggerClassName={cx(css.trigger, triggerClassName)}
    trigger={
      <>
        {typeof trigger === 'string' ? (
          <Text as="div" fontWeight="semiBold" textAlign="start">
            {trigger}
          </Text>
        ) : (
          trigger
        )}

        <Button
          aria-label="Learn more"
          as="span"
          className={cx(css.button, buttonClassName)}
          icon="CaretDown"
          variant="secondary"
        />
      </>
    }
    {...otherProps}
  />
);
